import type { ApiProblem } from "./types";

export type ApiErrorKind =
  | "rejected"
  | "conflict"
  | "unauthorized"
  | "forbidden"
  | "not-found"
  | "unavailable"
  | "cancelled"
  | "outcome-unknown";

interface ApiErrorOptions {
  kind: ApiErrorKind;
  status?: number;
  code?: string;
  correlationId?: string;
  problem?: ApiProblem;
  cause?: unknown;
}

export class ApiError extends Error {
  readonly kind: ApiErrorKind;
  readonly status?: number;
  readonly code?: string;
  readonly correlationId?: string;
  readonly problem?: ApiProblem;

  constructor(message: string, options: ApiErrorOptions) {
    super(message, { cause: options.cause });
    this.name = "ApiError";
    this.kind = options.kind;
    this.status = options.status;
    this.code = options.code;
    this.correlationId = options.correlationId;
    this.problem = options.problem;
  }
}
